import { lazy } from 'react';
const FabricDrilldown = lazy(() => import('./fabricdrilldown'));

const fabricdrilldownRoutes = [
  {
    path: '/fabricdrilldown',
    component: FabricDrilldown
  }
];

export default fabricdrilldownRoutes;
